export const GET_LOCATIONS = "GET_LOCATIONS";
export const USER_DATA = "USER_DATA";
export const DEFAULT_STATE = "DEFAULT_STATE";
export const UPDATE_DEFAULT = "UPDATE_DEFAULT";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_SIDEBAR = "UPDATE_SIDEBAR";
export const NOTIFICATION_DATA = "NOTIFICATION_DATA";
